import { render, staticRenderFns } from "./SelectInputComponent.vue?vue&type=template&id=0977d07e&scoped=true&"
import script from "./SelectInputComponent.vue?vue&type=script&lang=js&"
export * from "./SelectInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputComponent.vue?vue&type=style&index=0&id=0977d07e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977d07e",
  null
  
)

export default component.exports